import { TrendUpIcon } from '@phosphor-icons/react';
import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { requireModules } from '../../route';
import { Route as procurementFiltersRoute } from '../filters/route';
import { OrderStatusNavItem } from '../OrderStatusNavItem';
import { buyingBoardSearchSchema } from '../replenishment/utils/buyingBoardSearch';

const InternalTransfersRoutePage = lazyRouteComponent(
  () => import('./InternalTransfersRoutePage'),
  'InternalTransfersRoutePage',
);

// Outgoing Transfer Orders: the Transfer Supply board (GEN-3026), the buyer
// board with a source location as the vendor, and the staged draft transfers
// as a second tab. Under the procurement filter route like the buyer board.
export const Route = createRoute({
  getParentRoute: () => procurementFiltersRoute,
  path: '/procurement/internal-transfers',
  staticData: {
    app: {
      nav: {
        label: msg('Outgoing Transfer Orders', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <TrendUpIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 31,
        groupOrder: 30,
        subItems: <OrderStatusNavItem type="transfer" />,
      },
      // Stable id: the route id changed when it moved under the filter route.
      performance: {
        pageId: 'procurement-internal-transfers',
        readiness: 'route-rendered',
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAllOf: [
          { action: Action.Read, subject: Subject.PurchaseOrder },
          { action: Action.Create, subject: Subject.PurchaseOrder },
        ],
      },
    },
  },
  component: InternalTransfersRoutePage,
  validateSearch: buyingBoardSearchSchema.extend({
    // Which tab: the board, or the staged draft transfers.
    tab: z.enum(['board', 'staged']).optional().catch(undefined),
    // A staged draft transfer to focus (opens the staged tab).
    transferId: z.uuid().optional(),
    focus: z.boolean().optional(),
    // The board's selected source location, in place of supplierId.
    sourceId: z.uuid().optional(),
    // The board's source-location filter.
    sourceIds: z.array(z.uuid()).optional().catch(undefined),
  }),
  loader: () => ({
    crumb: msg('Outgoing Transfer Orders', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
